/* 🤖 this file was generated by svg-to-ts */
export const matIconSportsScore: {
  name: 'sports-score';
  data: string;
} = {
  name: 'sports-score',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z"/></svg>`
};
